import { Injectable } from "@angular/core";
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { Sim } from '@jonz94/capacitor-sim';
import { Platform } from "@ionic/angular";
import { Observable, from } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DeviceInfoService {
    constructor(
        private platform: Platform,
        private http: HttpClient
    ) { }

    getDeviceId(): Observable<string> {
        return from(
            Device.getId().then(id => id.identifier).catch(error => {
                console.error('Error fetching device ID:', error);
                return "unknown device id";
            })
        );
    }

    getAppVersion(): Observable<string | null> {
        if (!this.platform.is('capacitor')) {
            return new Observable((observer) => {
                observer.next(null);
                observer.complete();
            });
        }

        return from(
            App.getInfo().then(info => `${info.version} | ${info.build}`).catch(error => {
                console.error('Error fetching app version:', error);
                return null;
            })
        );
    }

    getPhoneNumber(): Observable<string | null | undefined> {
        if (!this.platform.is('capacitor')) {
            return new Observable((observer) => {
                observer.next(null);
                observer.complete();
            });
        }

        return from(
            Sim.getSimCards()
                .then(({ simCards }) => {
                    const simWithNumber = simCards.find(sim => sim.number);
                    return simWithNumber ? simWithNumber.number : null;
                })
                .catch(error => {
                    console.error('Error fetching SIM cards:', error);
                    return null;
                })
        );
    }

    getDeviceName(): Observable<string | null> {
        return this.getDeviceId().pipe(
            switchMap(deviceId => {
                const headers = new HttpHeaders({
                    'X-API-KEY': environment.apiKey
                });

                return this.http.get<{ deviceId: string, deviceName: string | null }>(
                    `${environment.apiBaseUrl}/courier/get-device-info?deviceId=${deviceId}`,
                    { headers }
                ).pipe(
                    map(response => response.deviceName),
                    catchError(error => {
                        console.error('Error fetching device name:', error);
                        return of(null);
                    })
                );
            })
        );
    }
}
